<template>
<ItpBox
  alignItems="center"
  class="items-spacing w-100"
  v-if="loaded"
>
  <ItpBox
    direction="column"
  >
    <ItpText
      muted
      :text="resourceTitle"
      class="mb-0"
      v-if="resourceTitle"
    >
    </ItpText>
    <ItpText
      tag="h5"
      :text="resourceKey"
      class="mb-0"
    >
    </ItpText>
  </ItpBox>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      v-if="!item.isNew"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
    </ItpButton>
    <b-dropdown
      right
      variant="light"
      class="border"
      v-if="!item.isNew"
    >
      <ItpIcon
        fa="bars"
        class="mx-1"
        slot="button-content"
      >
      </ItpIcon>
      <ItpButton
        dropdown-item
        :text="'Lock'|pgettext('BtnLockText')"
        :tooltip="'Lock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_lock"
        @click.prevent.stop="evh_3601807637515735_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Unlock'|pgettext('BtnLockText')"
        :tooltip="'Unlock'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_unlock"
        @click.prevent.stop="evh_4139696446929656_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Invalidate'|pgettext('BtnLockText')"
        :tooltip="'Invalidate'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_invalidate"
        @click.prevent.stop="evh_4700643919467772_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        dropdown-item
        :text="'Revoke invalidated'|pgettext('BtnLockText')"
        :tooltip="'Revoke invalidated'|pgettext('BtnLockTooltip')"
        variant="default"
        v-if="!item.isNew && item.meta && item.meta.can_revoke_invalidation"
        @click.prevent.stop="evh_295664594794476_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        no-icon
        dropdown-item
        :resource="item"
        :tooltip="'Delete'|pgettext('Resource|Command')"
        v-if="!item.isNew && !item.isReadOnly"
        @success="evh_8474446275270171_success($event, {})"
      >
      </BtnDeleteResource>
    </b-dropdown>
  </b-button-group>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcBillingListItemHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  messages!: any;
  ux!: any;
  dataMembers = ['messages', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          newItem: this.$fn.pgettext("BillingListItem", "New item"),
          editItem: this.$fn.pgettext("BillingListItem", "Edit item"),
        }
        ,
        ux: null,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("BillingListItem", "Billing list item")
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return this.item.isNew ? this.messages.newItem : this.messages.editItem
    }
    return null;
  }

  async act_1040167445267876_emit_6538_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1040167445267876_emit_6538, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3601807637515735_emit_6542_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3601807637515735_emit_6542, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_3601807637515735_reloadSlickgrid_6544_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3601807637515735_reloadSlickgrid_6544, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_3601807637515735_request_6540_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3601807637515735_request_6540, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: true,
      },
    }
  }

  async evh_3601807637515735_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4139696446929656_emit_6548_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4139696446929656_emit_6548, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4139696446929656_reloadSlickgrid_6550_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4139696446929656_reloadSlickgrid_6550, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4139696446929656_request_6546_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4139696446929656_request_6546, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        locked: false,
      },
    }
  }

  async evh_4139696446929656_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4139696446929656_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_4700643919467772_emit_6554_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4700643919467772_emit_6554, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_4700643919467772_reloadSlickgrid_6556_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4700643919467772_reloadSlickgrid_6556, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_4700643919467772_request_6552_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4700643919467772_request_6552, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: true,
      },
    }
  }

  async evh_4700643919467772_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4700643919467772_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_295664594794476_emit_6560_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_295664594794476_emit_6560, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_295664594794476_reloadSlickgrid_6562_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_295664594794476_reloadSlickgrid_6562, alias=undefined
    return {
      grid: "register",
    }
  }

  async act_295664594794476_request_6558_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_295664594794476_request_6558, alias=lock
    return {
      operation: "update_register_item",
      data: {
        id: this.item.id,
        etag: this.item.etag,
        void: false,
      },
    }
  }

  async evh_295664594794476_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_295664594794476_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8474446275270171_emit_6564_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8474446275270171_emit_6564, alias=undefined
    return {
      event: "deleted",
    }
  }

  async evh_8474446275270171_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8474446275270171_success.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_emit_6538: actions.EmitAction;
    evh_1040167445267876_clickPreventStop_6537: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
    act_3601807637515735_emit_6542: actions.EmitAction;
    evh_3601807637515735_success_6541: actions.EventHandlerImpl;
    act_3601807637515735_reloadSlickgrid_6544: actions.ReloadSlickgridAction;
    evh_3601807637515735_success_6543: actions.EventHandlerImpl;
    act_3601807637515735_request_6540: actions.RequestAction;
    evh_3601807637515735_clickPreventStop_6539: actions.EventHandlerImpl;
    evh_3601807637515735_clickPreventStop: actions.EventHandlerGroup;
    act_4139696446929656_emit_6548: actions.EmitAction;
    evh_4139696446929656_success_6547: actions.EventHandlerImpl;
    act_4139696446929656_reloadSlickgrid_6550: actions.ReloadSlickgridAction;
    evh_4139696446929656_success_6549: actions.EventHandlerImpl;
    act_4139696446929656_request_6546: actions.RequestAction;
    evh_4139696446929656_clickPreventStop_6545: actions.EventHandlerImpl;
    evh_4139696446929656_clickPreventStop: actions.EventHandlerGroup;
    act_4700643919467772_emit_6554: actions.EmitAction;
    evh_4700643919467772_success_6553: actions.EventHandlerImpl;
    act_4700643919467772_reloadSlickgrid_6556: actions.ReloadSlickgridAction;
    evh_4700643919467772_success_6555: actions.EventHandlerImpl;
    act_4700643919467772_request_6552: actions.RequestAction;
    evh_4700643919467772_clickPreventStop_6551: actions.EventHandlerImpl;
    evh_4700643919467772_clickPreventStop: actions.EventHandlerGroup;
    act_295664594794476_emit_6560: actions.EmitAction;
    evh_295664594794476_success_6559: actions.EventHandlerImpl;
    act_295664594794476_reloadSlickgrid_6562: actions.ReloadSlickgridAction;
    evh_295664594794476_success_6561: actions.EventHandlerImpl;
    act_295664594794476_request_6558: actions.RequestAction;
    evh_295664594794476_clickPreventStop_6557: actions.EventHandlerImpl;
    evh_295664594794476_clickPreventStop: actions.EventHandlerGroup;
    act_8474446275270171_emit_6564: actions.EmitAction;
    evh_8474446275270171_success_6563: actions.EventHandlerImpl;
    evh_8474446275270171_success: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_emit_6538 = new actions.EmitAction(
      {
        actionArgs: this.act_1040167445267876_emit_6538_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_6537 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_emit_6538,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_6537],
      }
    );
    const act_3601807637515735_emit_6542 = new actions.EmitAction(
      {
        actionArgs: this.act_3601807637515735_emit_6542_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6541 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_emit_6542,
        event: "success",
        displayName: "emit",
      }
    );
    const act_3601807637515735_reloadSlickgrid_6544 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3601807637515735_reloadSlickgrid_6544_getActionArgs,
        events: [],
      }
    );
    const evh_3601807637515735_success_6543 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_reloadSlickgrid_6544,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3601807637515735_request_6540 = new actions.RequestAction(
      {
        actionArgs: this.act_3601807637515735_request_6540_getActionArgs,
        displayName: "lock",
        events: [evh_3601807637515735_success_6541, evh_3601807637515735_success_6543],
      }
    );
    const evh_3601807637515735_clickPreventStop_6539 = new actions.EventHandlerImpl(
      {
        action: act_3601807637515735_request_6540,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_3601807637515735_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3601807637515735_clickPreventStop_6539],
      }
    );
    const act_4139696446929656_emit_6548 = new actions.EmitAction(
      {
        actionArgs: this.act_4139696446929656_emit_6548_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6547 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_emit_6548,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4139696446929656_reloadSlickgrid_6550 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4139696446929656_reloadSlickgrid_6550_getActionArgs,
        events: [],
      }
    );
    const evh_4139696446929656_success_6549 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_reloadSlickgrid_6550,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4139696446929656_request_6546 = new actions.RequestAction(
      {
        actionArgs: this.act_4139696446929656_request_6546_getActionArgs,
        displayName: "lock",
        events: [evh_4139696446929656_success_6547, evh_4139696446929656_success_6549],
      }
    );
    const evh_4139696446929656_clickPreventStop_6545 = new actions.EventHandlerImpl(
      {
        action: act_4139696446929656_request_6546,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4139696446929656_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4139696446929656_clickPreventStop_6545],
      }
    );
    const act_4700643919467772_emit_6554 = new actions.EmitAction(
      {
        actionArgs: this.act_4700643919467772_emit_6554_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6553 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_emit_6554,
        event: "success",
        displayName: "emit",
      }
    );
    const act_4700643919467772_reloadSlickgrid_6556 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4700643919467772_reloadSlickgrid_6556_getActionArgs,
        events: [],
      }
    );
    const evh_4700643919467772_success_6555 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_reloadSlickgrid_6556,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4700643919467772_request_6552 = new actions.RequestAction(
      {
        actionArgs: this.act_4700643919467772_request_6552_getActionArgs,
        displayName: "lock",
        events: [evh_4700643919467772_success_6553, evh_4700643919467772_success_6555],
      }
    );
    const evh_4700643919467772_clickPreventStop_6551 = new actions.EventHandlerImpl(
      {
        action: act_4700643919467772_request_6552,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_4700643919467772_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4700643919467772_clickPreventStop_6551],
      }
    );
    const act_295664594794476_emit_6560 = new actions.EmitAction(
      {
        actionArgs: this.act_295664594794476_emit_6560_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6559 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_emit_6560,
        event: "success",
        displayName: "emit",
      }
    );
    const act_295664594794476_reloadSlickgrid_6562 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_295664594794476_reloadSlickgrid_6562_getActionArgs,
        events: [],
      }
    );
    const evh_295664594794476_success_6561 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_reloadSlickgrid_6562,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_295664594794476_request_6558 = new actions.RequestAction(
      {
        actionArgs: this.act_295664594794476_request_6558_getActionArgs,
        displayName: "lock",
        events: [evh_295664594794476_success_6559, evh_295664594794476_success_6561],
      }
    );
    const evh_295664594794476_clickPreventStop_6557 = new actions.EventHandlerImpl(
      {
        action: act_295664594794476_request_6558,
        event: "click.prevent.stop",
        displayName: "lock",
      }
    );
    const evh_295664594794476_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_295664594794476_clickPreventStop_6557],
      }
    );
    const act_8474446275270171_emit_6564 = new actions.EmitAction(
      {
        actionArgs: this.act_8474446275270171_emit_6564_getActionArgs,
        events: [],
      }
    );
    const evh_8474446275270171_success_6563 = new actions.EventHandlerImpl(
      {
        action: act_8474446275270171_emit_6564,
        event: "success",
        displayName: "emit",
      }
    );
    const evh_8474446275270171_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_8474446275270171_success_6563],
      }
    );
    return {
      act_1040167445267876_emit_6538,
      evh_1040167445267876_clickPreventStop_6537,
      evh_1040167445267876_clickPreventStop,
      act_3601807637515735_emit_6542,
      evh_3601807637515735_success_6541,
      act_3601807637515735_reloadSlickgrid_6544,
      evh_3601807637515735_success_6543,
      act_3601807637515735_request_6540,
      evh_3601807637515735_clickPreventStop_6539,
      evh_3601807637515735_clickPreventStop,
      act_4139696446929656_emit_6548,
      evh_4139696446929656_success_6547,
      act_4139696446929656_reloadSlickgrid_6550,
      evh_4139696446929656_success_6549,
      act_4139696446929656_request_6546,
      evh_4139696446929656_clickPreventStop_6545,
      evh_4139696446929656_clickPreventStop,
      act_4700643919467772_emit_6554,
      evh_4700643919467772_success_6553,
      act_4700643919467772_reloadSlickgrid_6556,
      evh_4700643919467772_success_6555,
      act_4700643919467772_request_6552,
      evh_4700643919467772_clickPreventStop_6551,
      evh_4700643919467772_clickPreventStop,
      act_295664594794476_emit_6560,
      evh_295664594794476_success_6559,
      act_295664594794476_reloadSlickgrid_6562,
      evh_295664594794476_success_6561,
      act_295664594794476_request_6558,
      evh_295664594794476_clickPreventStop_6557,
      evh_295664594794476_clickPreventStop,
      act_8474446275270171_emit_6564,
      evh_8474446275270171_success_6563,
      evh_8474446275270171_success,
      reload: act_1040167445267876_emit_6538,
      lock: act_295664594794476_request_6558,
    }
  }
}

Vue.component("UcBillingListItemHeader", UcBillingListItemHeader);

</script>